<template>
    <v-container grid-list-xs fluid>
        <v-card outlined>
            <div v-if="Object.keys(SelectedCustomer).length === 0">
                <v-toolbar dense dark color="secondary" rounded flat>
                    <v-tooltip right color="#5499C7">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dense
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click="handleCustomerChange"
                            >
                                Change
                                <v-icon dense>mdi-account-switch</v-icon>
                            </v-btn>
                        </template>
                        <span>Change customer</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        Reconciliation <strong> Loading... </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div style="width: 118px; height: 36px;"></div>
                </v-toolbar>

                <v-container
                    grid-list-xs
                    fluid
                    style="padding: 20px 80px 50px;"
                >
                    <v-row style="margin-top: 10px;">
                        <v-col cols="12">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    Loading...
                                </legend>
                                <v-row style="padding: 25px 50px 30px 55px;">
                                    <v-col cols="4">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                    </v-row>

                    <v-row style="margin-top: 35px;">
                        <v-col cols="6">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    Loading...
                                </legend>
                                <v-row style="padding: 25px 55px 30px 55px;">
                                    <v-col cols="8">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                        <v-col cols="6">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    Loading...
                                </legend>
                                <v-row style="padding: 25px 55px 30px 55px;">
                                    <v-col cols="4">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-skeleton-loader
                                            height="40"
                                            type="card"
                                        ></v-skeleton-loader>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                    </v-row>

                    <v-row style="margin-top: 50px;">
                        <v-col cols="4"></v-col>
                        <v-col cols="4">
                            <v-skeleton-loader
                                height="40"
                                type="card"
                            ></v-skeleton-loader>
                        </v-col>
                        <v-col cols="4"></v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-else>
                <v-toolbar dense dark color="secondary" rounded flat>
                    <v-tooltip right color="#5499C7">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dense
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click="handleCustomerChange"
                            >
                                Change
                                <v-icon dense>mdi-account-switch</v-icon>
                            </v-btn>
                        </template>
                        <span>Change customer</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        Reconciliation
                        <strong> {{ SelectedCustomer.Name }} </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div style="width: 118px; height: 36px;"></div>
                </v-toolbar>

                <v-container
                    grid-list-xs
                    fluid
                    style="padding: 20px 30px 50px;"
                >
                    <v-row style="margin-top: 10px;">
                        <v-col cols="12">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    Reports By Date Range
                                </legend>
                                <v-row style="padding: 15px 10px 10px 55px;">
                                    <v-col cols="4">
                                        <v-select
                                            v-model="SelectedReportDate"
                                            :items="reportList"
                                            label="Select a report"
                                            item-text="Name"
                                            item-value="Value"
                                            dense
                                            outlined
                                            hide-details
                                            style="padding-top: 10px;"
                                            return-object
                                            :menu-props="reportSelectorProps"
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="startDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            placeholder="YYYY-MM-DD"
                                            v-mask="'####-##-##'"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            v-model="endDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            placeholder="YYYY-MM-DD"
                                            v-mask="'####-##-##'"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn
                                            dense
                                            outlined
                                            @click="
                                                handleGetReport('date-range')
                                            "
                                            style="margin-top: 10px;margin-left: 15px;"
                                            color="secondary"
                                        >
                                            Get report
                                            <v-icon dense>mdi-finance</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                    </v-row>

                    <v-row style="margin-top: 35px;">
                        <v-col cols="6">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    Reconciliation By Invoice
                                </legend>
                                <v-row style="padding: 15px 10px 30px 55px;">
                                    <v-col cols="8">
                                        <v-combobox
                                            v-model="SelectedInvoice"
                                            :items="invoiceList"
                                            label="Select an invoice"
                                            item-text="Text"
                                            item-value="InvId"
                                            dense
                                            outlined
                                            hide-details
                                            style="padding-top: 10px;"
                                            auto-select-first
                                            :loading="invoiceLoading"
                                            :disabled="invoiceLoading"
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    dense
                                                    outlined
                                                    @click="
                                                        handleMatchesByInvoice
                                                    "
                                                    color="teal"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    style="margin-top: 10px;"
                                                >
                                                    Reconcile
                                                    <v-icon dense>
                                                        mdi-scale-balance
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span
                                                >Matched and Unmatched
                                                BOLs</span
                                            >
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                        <v-col cols="6">
                            <fieldset
                                style="border-radius: 8px;border: 1px solid #bababa;"
                            >
                                <legend style="margin-left: 60px">
                                    File List
                                </legend>
                                <v-row style="padding: 15px 40px 30px 55px;">
                                    <!--<v-col cols="4">
                                        <v-select
                                            v-model="SelectedReportFile"
                                            :items="reportListFile"
                                            label="Select a report"
                                            item-text="Name"
                                            item-value="Value"
                                            dense
                                            outlined
                                            hide-details
                                            style="padding-top: 10px;"
                                            return-object
                                            :menu-props="reportSelectorProps"
                                        ></v-select>
                                    </v-col>-->
                                    <v-col cols="6">
                                        <v-combobox
                                            v-model="SelectedFilePayment"
                                            :items="filePaymentList"
                                            label="Select a file"
                                            item-text="Text"
                                            item-value="FilenameCode"
                                            dense
                                            outlined
                                            hide-details
                                            style="padding-top: 10px;"
                                            auto-select-first
                                            :loading="fileLoading"
                                            :disabled="fileLoading"
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn
                                            dense
                                            outlined
                                            @click="handleGetReport('file')"
                                            color="secondary"
                                            style="margin-top: 10px;"
                                        >
                                            Open report
                                            <v-icon dense>
                                                mdi-chart-box-multiple
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-btn
                                            dense
                                            outlined
                                            @click="confirmDeleteFile.Open"
                                            color="error"
                                            style="margin-top: 10px;"
                                        >
                                            Delete file
                                            <v-icon dense>
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                    </v-row>

                    <div v-if="PreviewFile.Show">
                        <v-row style="margin-top: 43px;">
                            <v-col cols="12">
                                <v-card outlined>
                                    <v-card-title
                                        style="padding-top: 30px;padding-bottom: 30px;"
                                    >
                                        FilenameCode:
                                        {{ PreviewFile.FilenameCode }}
                                        <v-spacer></v-spacer>
                                        <v-row>
                                            <v-col cols="3">
                                                <v-btn
                                                    dense
                                                    outlined
                                                    @click="handleSaveFileData"
                                                    color="success"
                                                >
                                                    Confirm Upload
                                                    <v-icon dense>
                                                        mdi-file-upload
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn
                                                    dense
                                                    outlined
                                                    @click="handleChangeFile"
                                                    color="warning"
                                                >
                                                    Change File
                                                    <v-icon dense>
                                                        mdi-file-replace
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="PreviewFile.Search"
                                                    append-icon="mdi-magnify"
                                                    label="Search here"
                                                    hide-details
                                                    style="padding-top: 0;margin-top: 0;"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-data-table
                                        :headers="PreviewFile.Headers"
                                        :items="PreviewFile.Data"
                                        dense
                                        fixed-header
                                        :search="PreviewFile.Search"
                                    >
                                        <template slot="body.append">
                                            <tr>
                                                <td
                                                    v-for="(hd,
                                                    idx) in PreviewFile.Headers"
                                                    :key="idx"
                                                >
                                                    <strong
                                                        v-if="
                                                            PreviewFile.Totals[
                                                                hd.value
                                                            ] !== undefined &&
                                                                PreviewFile
                                                                    .Totals[
                                                                    hd.value
                                                                ] !== '$NaN'
                                                        "
                                                        class="text-left font-weight-bold"
                                                    >
                                                        {{
                                                            PreviewFile.Totals[
                                                                hd.value
                                                            ]
                                                        }}
                                                    </strong>
                                                    <strong
                                                        v-else
                                                        class="text-left font-weight-bold"
                                                    ></strong>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row style="margin-top: 50px;">
                            <v-col cols="4"></v-col>
                            <v-col cols="4">
                                <v-file-input
                                    label="Add a new file here"
                                    outlined
                                    dense
                                    hide-details
                                    show-size
                                    v-model="newFile"
                                    @change="handlePrepareFileData"
                                    :multiple="SelectedCustomer.MultipleImport"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </div>
        </v-card>

        <!-- children components -->
        <ConcilCustomers
            v-if="$store.state.concil.customerSelection"
            @close="onConcilCustomersClose"
        ></ConcilCustomers>

        <ConcilMatchedDataPanel
            v-if="$store.state.concil.matchedDataPanel"
            :MatchedData="matchedData"
            @close="handleMatchesByInvoice"
        ></ConcilMatchedDataPanel>

        <!-- reports -->
        <ConcilGenericReport
            v-if="$store.state.concil.genericReport"
            :ReportData="reportData"
        ></ConcilGenericReport>

        <StmtSumByDateRange
            v-if="$store.state.concil.reports.StmtSumByDateRange"
            :ReportData="reportData"
        ></StmtSumByDateRange>

        <StmtSumRepByStmt
            v-if="$store.state.concil.reports.StmtSumRepByStmt"
            :ReportData="reportData"
        ></StmtSumRepByStmt>

        <!--<InvSumByDateRange
            v-if="$store.state.concil.reports.InvSumByDateRange"
            :ReportData="reportData"
        ></InvSumByDateRange>-->

        <v-dialog
            v-model="filenameCodeInconsistency.Show"
            persistent
            max-width="800px"
            transition="dialog-bottom-transition"
        >
            <v-card outlined style="padding: 20px;">
                <v-card-title>
                    File Inconsistency
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="filenameCodeInconsistency.Search"
                        append-icon="mdi-magnify"
                        label="Search here"
                        hide-details
                        style="padding-top: 0;margin-top: 0;"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="filenameCodeInconsistency.Close">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text style="font-size: 16px;margin-top: 15px;"
                    >One or more files do not match expected filename
                    code</v-card-text
                >
                <v-data-table
                    :headers="filenameCodeInconsistency.Headers"
                    :items="filenameCodeInconsistency.Data"
                    dense
                    fixed-header
                    :search="filenameCodeInconsistency.Search"
                ></v-data-table>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="confirmDeleteFile.Show"
            persistent
            max-width="500px"
            transition="dialog-bottom-transition"
        >
            <v-card outlined style="padding: 20px;">
                <v-card-title>
                    File delete confirmation
                </v-card-title>
                <v-card-text style="font-size: 16px;margin-top: 15px;">
                    <p>Are you sure you want to delete this file?</p>
                    <p>
                        <strong>{{ confirmDeleteFile.Text }}</strong>
                    </p>
                </v-card-text>
                <div
                    style="display: flex;justify-content: space-between;padding: 0 15px 15px 15px;"
                >
                    <v-btn color="error" @click="handleDeleteFileData">
                        Delete
                    </v-btn>
                    <v-btn text @click="confirmDeleteFile.Close">
                        Cancel
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from 'axios';
import * as XLSX from 'xlsx/xlsx.js';
import { mask } from 'vue-the-mask';

import ConcilCustomers from './ConcilCustomers.vue';
import ConcilMatchedDataPanel from './ConcilMatchedDataPanel.vue';

// Reports
import ConcilGenericReport from './ConcilGenericReport.vue';
import StmtSumByDateRange from './Reports/StmtSumByDateRange.vue';
import StmtSumRepByStmt from './Reports/StmtSumRepByStmt.vue';
//import InvSumByDateRange from './Reports/InvSumByDateRange.vue';

export default {
    directives: { mask },
    components: {
        ConcilCustomers,
        ConcilMatchedDataPanel,
        ConcilGenericReport,
        StmtSumByDateRange,
        StmtSumRepByStmt
        //InvSumByDateRange,
    },
    data: function() {
        return {
            SelectedCustomer: {},
            SelectedReportDate: {},
            SelectedReportFile: {},
            SelectedReport: {},
            startDate: '',
            endDate: '',
            reportList: [
                {
                    Name: 'Invoice Summary',
                    Alias: 'InvoiceSummary',
                    Value: 1,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Outstanding BOLs',
                    Alias: 'OutstandingBOLs',
                    Value: 2,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Outstanding BOLs By Amount',
                    Alias: 'OutstandingBOLsByAmount',
                    Value: 6,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Statement Uploaded By Clearing Doc',
                    Alias: 'StmtUpByClearingDoc',
                    Value: 3,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Statement Summary By Date Range',
                    Alias: 'StmtSumByDateRange',
                    Value: 4,
                    IsDirectXlsx: false,
                },
                { 
                    Name: 'Payment History By Date Range', 
                    Alias: 'PayHistByDateRange',
                    Value: 5,
                    IsDirectXlsx: true,
                },
            ],
            reportListFile: [
                {
                    Name: 'Statement Summary Report By Statement',
                    Alias: 'StmtSumRepByStmt',
                    Value: 1,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Statement Summary Report By Statement Detail',
                    Alias: 'StmtSumRepByStmt', // same alias as 1
                    Value: 2,
                    IsDirectXlsx: false,
                },
                {
                    Name: 'Accounting Match View By Statement',
                    Alias: 'AccMatchViewByStmt',
                    Value: 3,
                    IsDirectXlsx: false,
                }
            ],
            reportData: [],
            filePaymentList: [],
            SelectedFilePayment: null,
            reportSelectorProps: {
                maxHeight: 400,
                offsetY: true,
                closeOnClick: true,
                width: 450
            },
            SelectedInvoice: null,
            invoiceList: [],
            invoiceLoading: true,
            fileLoading: true,
            matchedData: {},
            PreviewFile: {
                Show: false,
                Search: '',
                Headers: [],
                Data: [],
                FilenameCode: null,
                Totals: []
            },
            newFile: null,
            initLoadControl: 0,
            searchBy: '',
            filenameCode: null,
            filenameCodeInconsistency: {
                Show: false,
                Headers: [],
                Data: [],
                Search: '',
                Close: () => {
                    this.filenameCodeInconsistency.Show = false;
                    this.filenameCodeInconsistency.Headers = [];
                    this.filenameCodeInconsistency.Data = [];
                }
            },
            confirmDeleteFile: {
                Text: '',
                Show: false,
                Open: () => {
                    if (this.SelectedFilePayment === null) {
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'You have to select a file.'
                        });
                        return;
                    }

                    this.confirmDeleteFile.Text = this.SelectedFilePayment.Text;
                    this.confirmDeleteFile.Show = true;
                },
                Close: () => {
                    this.confirmDeleteFile.Text = '';
                    this.confirmDeleteFile.Show = false;
                }
            }
        };
    },
    watch: {
        initLoadControl: function(newValue, oldValue) {
            console.log(oldValue, newValue);
            if (newValue === 2) {
                this.$store.state.isLoading = false;
            }
        }
    },
    mounted() {
        this.$store.state.concil.customerSelection = true;
    },
    methods: {
        handleGetReport: function(searchBy) {
            // Error handling
            if (searchBy == 'date-range') {
                console.log(this.SelectedReportDate);
                console.log(
                    'Start: ',
                    this.startDate,
                    ' | ',
                    'End: ',
                    this.endDate
                );

                if (Object.keys(this.SelectedReportDate).length === 0) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'You have to select a report.'
                    });
                    return;
                } else if (
                    this.startDate == null ||
                    this.startDate == '' ||
                    this.endDate == null || this.endDate == ''
                ) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Please choose a date range.'
                    });
                    return;
                }

                this.SelectedReport = this.SelectedReportDate;
            } else if (searchBy == 'file') {
                this.SelectedReportFile = this.reportListFile[0];
                console.log(this.SelectedReportFile);
                console.log(this.SelectedFilePayment);

                if (Object.keys(this.SelectedReportFile).length === 0) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'You have to select a report.'
                    });
                    return;
                } else if (this.SelectedFilePayment === null) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Please choose a file.'
                    });
                    return;
                }

                this.SelectedReport = this.SelectedReportFile;
            }

            this.searchBy = searchBy;
            this.getReport('view');
        },
        handleCustomerChange: function() {
            this.SelectedCustomer = {};
            this.initLoadControl = 0;
            this.$store.state.mini = true;
            this.$store.state.concil.customerSelection = true;
        },
        onConcilCustomersClose: function(customerParams) {
            console.log('customerParams: ', customerParams);
            this.$store.state.isLoading = true;
            this.SelectedCustomer = customerParams;
            this.SelectedReportDate = {};
            this.SelectedReportFile = {};
            this.SelectedReport = {};
            this.SelectedInvoice = null;
            this.SelectedFilePayment = null;
            this.handleChangeFile();
            this.getInvoiceList();
            this.getFileList('init');
        },
        setParams: function() {
            let params = {
                Customer: this.SelectedCustomer,
                Report: this.SelectedReport,
                SearchBy: this.searchBy
            };

            if (params.SearchBy == 'date-range') {
                params.StartDate = this.startDate;
                params.EndDate = this.endDate;
                params.Filename = 'Rec_' +
                    this.SelectedCustomer.Alias +
                    '_' +
                    this.SelectedReport.Alias +
                    '_' +
                    this.startDate +
                    '_' +
                    this.endDate +
                    '.xlsx';
            } else if (params.SearchBy == 'file') {
                params.File = this.SelectedFilePayment;
                params.Filename = 'Rec_' +
                    this.SelectedCustomer.Alias +
                    '_' +
                    this.SelectedReport.Alias +
                    '.xlsx';
            }

            console.log(params);
            return params;
        },
        getReport: async function(requestType) {
            let str = this.$store;
            let params = this.setParams();
            let responseType = this.SelectedReport.IsDirectXlsx ? 'blob' : 'json';
            str.state.isLoading = true;
            await axios
                .post('conciliation/get/report/' + requestType, params, {
                    responseType
                })
                .then(response => {
                    if (this.SelectedReport.IsDirectXlsx) {
                        let data = response.data;
                        let url = window.URL.createObjectURL(new Blob([data]));
                        let link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', params.Filename);
                        document.body.appendChild(link);
                        link.click();
                        str.state.isLoading = false;
                    } else {
                        let data = response.data;
                        let sameVue = [
                            'InvoiceSummary',
                            'OutstandingBOLs',
                            'OutstandingBOLsByAmount',
                            'StmtUpByClearingDoc'
                        ];
                        this.reportData = {
                            Data: data,
                            Params: params
                        };
                        console.log(this.reportData);
                        str.state.isLoading = false;

                        if (sameVue.includes(this.SelectedReport.Alias)) {
                            console.log('asd');
                            this.$store.state.concil.genericReport = true;
                        } else {
                            this.$store.state.concil.reports[
                                this.SelectedReport.Alias
                            ] = true;
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        handleMatchesByInvoice: async function() {
            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                Invoice: this.SelectedInvoice,
                Customer: this.SelectedCustomer
            };

            console.log(params);
            await axios
                .post('conciliation/get/matches-by-invoice', params)
                .then(response => {
                    console.log(response.data);
                    this.matchedData = {
                        Data: response.data,
                        Params: params
                    };
                    str.state.isLoading = false;
                    this.$store.state.concil.matchedDataPanel = true;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        handlePrepareFileData: async function() {
            const str = this.$store;

            if (this.SelectedCustomer.Alias === 'Parkland') {
                str.state.isLoading = true;
                const filename = this.newFile.name;
                const fileReader = new FileReader();
                fileReader.onload = event => {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                        header: 1
                    });
                    console.log(jsonData);

                    let params = {
                        CustomerAlias: this.SelectedCustomer.Alias,
                        Data: jsonData,
                        Filename: filename
                    };

                    axios
                        .post('conciliation/prepare/file-data', params, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        .then(response => {
                            console.log(response.data);
                            this.PreviewFile.Headers = response.data.Headers;
                            this.PreviewFile.Data = response.data.Data;
                            this.PreviewFile.FilenameCode =
                                response.data.FilenameCode;
                            this.PreviewFile.Totals = response.data.Totals;
                            this.PreviewFile.Show = true;
                            str.state.isLoading = false;
                        })
                        .catch(error => {
                            console.error(error);
                            str.state.isLoading = false;
                            this.newFile = null;
                        });
                };
                fileReader.readAsArrayBuffer(this.newFile);
            } else {
                const formData = new FormData();
                console.log(this.newFile);

                if (this.SelectedCustomer.MultipleImport) {
                    for (let file of this.newFile) {
                        formData.append('files[]', file);
                    }
                } else {
                    formData.append('files[]', this.newFile);
                }

                formData.append('CustomerAlias', this.SelectedCustomer.Alias);
                console.log(formData);

                str.state.isLoading = true;
                await axios
                    .post('conciliation/prepare/file-data', formData, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        this.PreviewFile.Headers = response.data.Headers;
                        this.PreviewFile.Data = response.data.Data;
                        this.PreviewFile.FilenameCode =
                            response.data.FilenameCode;
                        this.PreviewFile.Totals = response.data.Totals;
                        this.PreviewFile.Show = true;
                        str.state.isLoading = false;
                    })
                    .catch(error => {
                        console.error(error);
                        str.state.isLoading = false;
                        if (error.response.status === 400) {
                            console.log(error.response.data);
                            this.filenameCodeInconsistency.Headers =
                                error.response.data.Headers;
                            this.filenameCodeInconsistency.Data =
                                error.response.data.Data;
                            this.filenameCodeInconsistency.Show = true;
                        }
                        this.newFile = null;
                    });
            }
        },
        handleSaveFileData: async function() {
            let str = this.$store;
            str.state.isLoading = true;
            console.log(this.PreviewFile.Headers);
            console.log(this.PreviewFile.Data);
            console.log(this.PreviewFile.FilenameCode);

            let params = {
                Customer: this.SelectedCustomer,
                Data: this.PreviewFile.Data,
                FilenameCode: this.PreviewFile.FilenameCode
            };
            console.log(params);

            await axios
                .post('conciliation/save/file-data', params)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'File uploaded successfully.'
                    });
                    this.handleChangeFile();
                    this.getFileList();
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                        this.handleChangeFile();
                    }
                });
        },
        handleDeleteFileData: async function() {
            let str = this.$store;
            str.state.isLoading = true;
            console.log(this.SelectedFilePayment);

            let params = {
                Customer: this.SelectedCustomer,
                File: this.SelectedFilePayment
            };
            console.log(params);

            await axios
                .post('conciliation/delete/file-data', params)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'File deleted successfully.'
                    });
                    this.SelectedFilePayment = null;
                    this.getFileList();
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        handleChangeFile: function() {
            this.PreviewFile.Headers = [];
            this.PreviewFile.Data = [];
            this.PreviewFile.Totals = [];
            this.PreviewFile.FilenameCode = '';
            this.newFile = null;
            this.PreviewFile.Show = false;
            console.log(this.PreviewFile);
        },
        getFileList: function(action = '') {
            this.fileLoading = true;
            axios
                .post('conciliation/get/file-list', this.SelectedCustomer)
                .then(response => {
                    console.log(response.data);
                    this.filePaymentList = response.data;
                    this.fileLoading = false;
                    if (action == 'init') {
                        this.initLoadControl++;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getInvoiceList: function() {
            this.invoiceLoading = true;
            axios
                .post('conciliation/get/invoice-list', this.SelectedCustomer)
                .then(response => {
                    console.log(response.data);
                    this.invoiceList = response.data;
                    this.invoiceLoading = false;
                    this.initLoadControl++;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.v-menu__content::-webkit-scrollbar {
    width: 8px;
}
.v-menu__content::-webkit-scrollbar-track {
    background: #d6eaf8;
}

.v-menu__content::-webkit-scrollbar-thumb {
    background: #01579b;
}
.v-menu__content::-webkit-scrollbar-thumb:hover {
    background: #154360;
}
</style>
